/* eslint-disable react/jsx-key */
import React, { useState } from 'react'
import { strCol, intCol, numCol } from '@integec/grid-tools/lib/cols'

import { getApiTargetInfo } from 'core'
import { modifierCol, modifiedDateCol } from 'core/HeaderColTypeProps'
import { connect } from 'react-redux'
import {
  getNercClassAvgEford,
  deleteNercClassAvgEford,
  saveNercClassAvgEford,
} from 'api/pgads.js'
import { Input, Button, InputNumber } from 'antd'
import CommonScreen from '../CommonScreen'
import { Label } from 'core/screen-util'

const headers = [
  intCol({
    ident: 'year',
    display: 'Year',
    isKey: true,
    sortOrder: 'desc',
  }),
  strCol({
    ident: 'nercClass',
    display: 'Class',
    isKey: true,
    width: 150,
    sortOrder: 'asc',
  }),
  numCol({
    ident: 'avgEford',
    display: 'Average EFORD',
    isKey: true,
    width: 200,
  }),
  modifierCol,
  modifiedDateCol,
]

const title = 'NERC Class Avg. EFORD'

const NercClassAverage = () => {
  const [insertEvent, setInsertEvent] = useState(false)

  const insertComp = ({ insertData, setInsertData, onAdd, onCancel }) => {
    return (
      <div
        style={{
          display: 'grid',
          gridTemplateColumns:
            '100px 150px 100px 150px 200px 150px min-content min-content min-content',
          gap: 10,
        }}
      >
        <Label>Year : </Label>

        <InputNumber
          value={insertData.year}
          maxLength={4}
          minLength={4}
          onChange={value => setInsertData({ ...insertData, year: value })}
        />
        <Label>Class : </Label>

        <Input
          value={insertData.nercClass}
          onChange={e =>
            setInsertData({ ...insertData, nercClass: e.target.value })
          }
        />

        <Label>Average EFORD : </Label>
        <InputNumber
          value={insertData.avgEford}
          max={99.9999}
          onChange={value => setInsertData({ ...insertData, avgEford: value })}
        />

        <Button type="primary" onClick={() => onAdd(true)}>
          Add
        </Button>
        <Button type="primary" onClick={() => onAdd(false)}>
          Add & Hide
        </Button>
        <Button type="danger" onClick={onCancel}>
          Cancel
        </Button>
      </div>
    )
  }
  return [
    <CommonScreen
      title={title}
      header={headers}
      saveTask={saveNercClassAvgEford}
      retrieveTask={getNercClassAvgEford}
      deleteTask={deleteNercClassAvgEford}
      altBy={d => d.class + '' + d.year}
      autoRetrieve
      sortOptions={headers}
      totalWidth={900}
      insertComp={insertEvent && insertComp}
      insertCompHeight={150}
      onInsertEvent={b => setInsertEvent(b)}
    />,
  ]
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
})

export default connect(mapStateToProps)(NercClassAverage)
